// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/lazyload.js'; import './autoload/marquee.js'; import './autoload/menu.js'; // eslint-disable-line

// Import local dependencies
import './autoload/lazyload';
import './autoload/marquee';
import { scrollIntoViewWithOffset } from './utils/helpers';

// Import plugins
import 'jquery-match-height';
import ScrollOut from 'scroll-out';

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Set CSS variable for header height
 */
const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  $('a[href*="#"]').on('click', function (e) {
    const url = $(this).attr('href');

    if (url.startsWith('http')) return;

    const currentPath = window.location.pathname;
    const linkPath = url.split('#')[0];

    if (linkPath && linkPath !== '' && linkPath !== currentPath) return;

    e.preventDefault();

    const targetId = '#' + url.split('#')[1];
    const $target = $(targetId);

    $('body').removeClass('menu-open');
    $('.menu-icon').removeClass('is-active');
    $('.top-bar').removeClass('is-active');

    setTimeout(function () {
      if ($target.length) {
        let offset = $('header').outerHeight() || 0;
        offset += window.innerWidth >= 1024 ? 0 : 0;

        $('html, body').animate(
          { scrollTop: $target.offset().top - offset },
          600
        );
      }
    }, 50);
  });

  const currentPath = window.location.pathname;

  if (currentPath === '/') {
    $(
      'li.current-menu-item a[href*="#"], li.current_page_item a[href*="#"]'
    ).each(function () {
      const url = $(this).attr('href');

      if (url.startsWith('/#')) {
        const $listItem = $(this).parent('li');

        $listItem.removeClass('current-menu-item current_page_item');

        $(this).removeAttr('aria-current');
      }
    });
  }

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    once: true,
    threshold: 0.4,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (_, formId) {
    let target = document.getElementById(
      `gform_confirmation_wrapper_${formId}`
    );

    if (target) {
      scrollIntoViewWithOffset(target, 100);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // Preloader
  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
